export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineLoad.worker.7fdfb4a1b3ed0996d97b-engineLoad.worker.worker.js");
}
